module.exports = __webpack_public_path__ + "img/logo.cfed7d22.svg";